var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVSmallTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 13,
    viewBox: "0 0 17 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector 10",
    d: "M7.69261 11.8952L0.62671 2.22602C-0.0492533 1.30102 0.611389 -8.83238e-07 1.75706 -8.3316e-07L15.2429 -2.43673e-07C16.3886 -1.93594e-07 17.0493 1.30102 16.3733 2.22602L9.30739 11.8951C8.90792 12.4418 8.09208 12.4418 7.69261 11.8952Z",
    fill: "#FE004E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVSmallTriangle);
export default __webpack_public_path__ + "static/media/V-Small-Triangle.fc2f2b8dc83d21a7e0100cebe9397347.svg";
export { ForwardRef as ReactComponent };